// extracted by mini-css-extract-plugin
var _1 = "#4c4c4c";
var _2 = "timeline_content__kyk8d";
var _3 = "640px";
var _4 = "790px";
var _5 = "#057676";
var _6 = "timeline_dot__j+qrv";
var _7 = "timeline_gray__cl+qp";
var _8 = "#434343";
var _9 = "timeline_line__seq4t";
var _a = "79px";
var _b = "110px";
var _c = "72px";
var _d = "665px";
var _e = "timeline_number__3h9gi";
var _f = "timeline_showonmobile__yvahe";
var _10 = "timeline_start__yvmrj";
var _11 = "teal";
var _12 = "2";
var _13 = "#cdd3dc";
export { _1 as "body", _2 as "content", _3 as "controlsMobileWidth", _4 as "controlsStackedWidth", _5 as "darkTeal", _6 as "dot", _7 as "gray", _8 as "headline", _9 as "line", _a as "menuHeight", _b as "menuHeightLarge", _c as "menuHeightMobile", _d as "modalMobileWidth", _e as "number", _f as "showOnMobile", _10 as "start", _11 as "teal", _12 as "timelineStrokeWidth", _13 as "timelineTrackColor" }
